import {getStartOfWeek} from '@igp/shared/utils';

export const PayoutReportServiceTypes = {
    service: Symbol('PayoutReportService'),
    downloadClientStrategy: Symbol('PayoutReportDownloadClientStrategy'),
    downloadServerStrategy: Symbol('PayoutReportDownloadServerStrategy'),
} as const;

const availableWeekCount = 14; // ~ 3 months
export const firstAvailableDate = getStartOfWeek(availableWeekCount);
